var map = {
	"./KeyboardMagnetic.vue": "a09a",
	"./LEDPCBMagnetic.vue": "fb99",
	"./PCBConverterMagnetic.vue": "9881",
	"./VirtualKeyboardMagnetic.vue": "836a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36e2";